import { useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerResourceGrid = props => {

  const datalayerResourceGridFilterClicks = event => {
    if (
      containsValidTargetClass(
        ["t2-dropdown__option-label"],
        event?.target?.classList
      )
    ) {
      const filtersAppliedCount = document?.querySelectorAll(".t2-dropdown__option-label--selected")?.length
      window.dataLayer.push({   
        event: "blog_filter_applied",   
        filter_category: event?.target?.closest('.t2-dropdown')?.children[0]?.innerText, //product, persona, sort by   
        filter_value: event?.target?.innerText,   
        filter_action: event?.target?.classList?.contains('t2-dropdown__option-label--selected') ? "applied" : "removed", //remove or applied   
        num_filters_applied: filtersAppliedCount,   
        current_page: window?.location?.href
      })
    }
  }

  const datalayerTabTitleClick = event => {
    if (
      containsValidTargetClass(
        ["react-tabs__tab"],
        event?.target?.classList
      )
    ) {
      window.dataLayer.push({   
        event: "blog_subnav_click",   
        content_view_type: event?.target?.innerText, //top stories, executive insights, construction, featured posts   
        current_page: window?.location?.href 
      });
    }
  }

  // add handler if relevant listener elem exists
  let filterQuery = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    filterQuery = document?.querySelectorAll(".t2-dropdown__trigger").length > 0
  }
  let tabClick = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    tabClick = document?.querySelectorAll(".react-tabs__tab").length > 0
  }

  useClickListener(datalayerResourceGridFilterClicks, filterQuery)
  useClickListener(datalayerTabTitleClick, tabClick)
}

export default DatalayerResourceGrid
